import deMessages from '../../_metronic/i18n/messages/de.json'
import enMessages from '../../_metronic/i18n/messages/en.json'
import esMessages from '../../_metronic/i18n/messages/es.json'
import frMessages from '../../_metronic/i18n/messages/fr.json'
import jaMessages from '../../_metronic/i18n/messages/ja.json'
import zhMessages from '../../_metronic/i18n/messages/zh.json'

import {fetchAppMessages} from './fetchAppMessages'
import {AppLocale, isAppLocale} from './config'

const metronicMessagesByLocale: Record<string, Record<string, string>> = {
  de: deMessages,
  en: enMessages,
  es: esMessages,
  fr: frMessages,
  ja: jaMessages,
  zh: zhMessages,
}

export type UiLocale = AppLocale | keyof typeof metronicMessagesByLocale

export function resolveMetronicMessages(locale: string): Record<string, string> {
  const metronicLocale =
    metronicMessagesByLocale[locale] !== undefined ? locale : 'en'

  return {...metronicMessagesByLocale[metronicLocale]}
}

export async function resolveMessages(locale: string): Promise<Record<string, string>> {
  const metronic = resolveMetronicMessages(locale)

  try {
    const app = await fetchAppMessages(locale)
    return {...metronic, ...app}
  } catch (error) {
    console.error('[i18n] Failed to load app messages at runtime.', error)
    return {...metronic}
  }
}
